export const ButtonLabels = Object.freeze({
  // Currently Used Values (from existing components)
  CLICK_HERE_TO_RELOAD: "Click here to reload",
  NO_CONTINUE: "No, Stay",
  YES_IAM_SURE: "Yes, Leave",

  // Forecast-specific Button Labels
  RUN_FORECAST: "Run Forecast",
  RUNNING_FORECAST: "Running Forecast...",
  CREATE_DRAFT_ORDER: "Create Draft Order",
  AUTO_ORDER: "Auto-Order",
  TRIGGERING_AUTO_ORDER: "Triggering...",
  CREATING_DRAFT_ORDER: "Creating...",
  EXPORT_CSV: "Export CSV",
  REFRESH: "Refresh",
  VIEW_RESULTS: "View Results",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
  RUN_DEMAND_FORECAST: "Run Demand Forecast",
  RUNNING_DEMAND_FORECAST: "Running Demand Forecast...",
  RUN_RETINA_FORECAST: "Run Retina Forecast",
  RUNNING_RETINA_FORECAST: "Running Retina Forecast...",

  // Additional Button Labels
  SAVING: "Saving...",
  SAVE_SETTINGS: "Save Settings",
  RESET_TO_DEFAULTS: "Reset to Defaults",
  STAY_LOGGED_IN: "Stay Logged In",
  LOG_OUT: "Log Out",
  VIEW_DETAILS: "View Details",
  DELETE: "Delete",
  PROCESSING: "Processing...",
  SUBMIT: "Submit",
  SELECT_DISTRIBUTORS: "Select Distributor(s)",
});
